<template>
  <div class='mvt-weather-card card-box p-y-2 p-x-2'>
    <div class="mvt-weather-card__current">
      <i class="icon-natural-light"></i>
      <span class="f3 text-bold">{{ currentTemp }}&deg;F</span>
    </div>
    <div class="grid grid-cols-2 gap-2 f6">
      <span class="text-right">L:{{ lowTemp }}&deg;F</span>
      <span class="text-left">H:{{ highTemp }}&deg;F</span>
    </div>
    <div class="text-center f6">
      <span>{{ month }} avg</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'mvtWeatherCard',
  props: {
    currentTemp: {
      type: Number,
      required: true,
    },
    currentIcon: {
      type: String,
      default: 'sun',
      required: false,
    },
    month: {
      type: String,
      required: true,
    },
    lowTemp: {
      type: Number,
      required: true,
    },
    highTemp: {
      type: Number,
      required: true,
    },
  }
};

</script>

<style lang="scss">
.mvt-weather-card {
  width: 100%;
  max-width: 175px;

  &__current {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: var(--g0);
  }

  .icon-natural-light {
    color: var(--color-r4);
    line-height: 1.5rem;
    font-size: 1.5rem;
  }
}
</style>